import { useSpring } from '@react-spring/web';
import { useId, useRef, useState } from 'react';
import useMeasure from '../useMeasure/useMeasure';
import { UseSlideToggleConfig } from './types';

export const useSlideToggle = ({
  name,
  minHeight,
  config,
  initialState = false,
}: UseSlideToggleConfig) => {
  const id = useId();
  const [isOpen, setIsOpen] = useState(initialState);
  const animatedElementRef = useRef<HTMLDivElement>(null);
  const { height } = useMeasure(animatedElementRef, true);

  const animationProps = useSpring({
    height: `${isOpen ? height : minHeight}px`,
    config,
  });

  const toggle = () => setIsOpen((value) => !value);

  return {
    animationProps,
    animatedElementRef,
    elementID: name + id,
    isOpen,
    toggle,
  };
};
